import {Box, Button, List, ListItem,} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import EditIcon from '@mui/icons-material/Edit';
import {TemplateActions, TemplateMetadata} from "../pages/app/types.ts";

const TemplateList = ({handleOpen, handleEdit, handleDelete, loading, tmpTemplates}: TemplateActions) => {
    return (
        <List sx={{width: '100%'}}>
            {tmpTemplates.length > 0 ?
                tmpTemplates.map((template: TemplateMetadata) => {
                    const {templateID, templateName, updatedAt} = template;
                    return (
                        <ListItem
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                borderColor: 'black',
                                backgroundColor: 'white',
                                borderRadius: 7,
                                padding: 4,
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                marginTop: 4
                            }}
                            key={templateID}
                            disablePadding
                        >
                            <Box style={{display: 'flex', width: '100%', flexWrap: 'wrap'}}>
                                <Box style={{flex: '1 1 auto', marginBottom: 8}}>
                                    <p>{templateName}</p>
                                    <p>{new Date(updatedAt).toLocaleDateString()}</p>
                                </Box>
                                <Box style={{
                                    display: 'flex',
                                    flex: '0 1 auto',
                                    justifyContent: 'flex-end',
                                    marginBottom: 8,
                                    flexWrap: 'wrap'
                                }}>
                                    <Button style={{color: 'red'}} onClick={()=>handleDelete(templateID)}>
                                        <DeleteIcon/>
                                    </Button>
                                    <Button style={{color: '#53b2ef'}} onClick={()=>handleEdit(template)}>
                                        <SettingsIcon/>
                                    </Button>
                                    <Button style={{color: '#53b2ef'}} onClick={()=>handleOpen(template)}>
                                        <EditIcon/>
                                    </Button>
                                </Box>
                            </Box>
                        </ListItem>
                    )
                })
                :
                !loading && <p>Noch keine Templates vorhanden</p>
            }
        </List>



    );
}
export default TemplateList;
